module.exports = __webpack_public_path__ + "img/dropdown.90fc16fd.gif";